import { all, fork, takeLatest } from 'redux-saga/effects';
import { fetchDetail, fetchTable, sendData } from '../helpers/sagaHelpers';

function* watchFetchAssignGarantTable() {
  yield takeLatest('assignGarant/fetchTable', fetchTable);
}
function* watchFetchAssignGarantDetail() {
  yield takeLatest('assignGarant/fetchDetail', fetchDetail);
}

function* watchSubmitAssignGarantDetail() {
  yield takeLatest('assignGarant/submitDetail', sendData);
}

export default function* rootSaga() {
  yield all([
    fork(watchFetchAssignGarantTable),
    fork(watchFetchAssignGarantDetail),
    fork(watchSubmitAssignGarantDetail)
  ]);
}
